import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const NoOcurrence = ({ message = "Nada consta" }) => {
  return (
    <div className="mt-4 bg-blue-50 border border-green-100 rounded-md p-4">
      <div className="flex items-center gap-3">
        <IoMdCheckmarkCircleOutline className="text-blue-600" size={24} />
        <span className="font-medium text-blue-700 text-sm">{message}</span>
      </div>
    </div>
  );
};
export default NoOcurrence;
